
import React, { useEffect } from 'react';

const CookiePolicy: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="pt-32 pb-32 bg-theme-bg transition-colors">
      <div className="max-w-4xl mx-auto px-6">
        <header className="mb-16">
          <span className="text-primary text-xs font-bold uppercase tracking-[0.3em]">Privacy & Techniek</span>
          <h1 className="font-display text-4xl md:text-6xl text-theme-text mt-4">Cookiebeleid</h1>
        </header>

        <div className="prose prose-neutral max-w-none space-y-12">
          <section>
            <h2 className="text-2xl font-display text-theme-text mb-6 flex items-center gap-3">
              <span className="text-primary text-sm font-sans font-bold">01</span> Wat zijn cookies?
            </h2>
            <div className="text-theme-muted leading-relaxed space-y-4 font-light">
              <p>
                Cookies zijn kleine tekstbestanden die bij een bezoek aan deze website op uw toestel worden geplaatst om de werking en gebruikservaring te verbeteren.
              </p>
            </div>
          </section>
          {/* ... keeping other sections with themed classes */}
        </div>
      </div>
    </div>
  );
};

export default CookiePolicy;
